module.exports = __webpack_public_path__ + "img/20191025171712551.4f0a1c5a.jpg";